<template>
  <main class="rh-config">
    <rh-cabecalho
      pagina="configuracao"
      subtitulo="CONFIGURAÇÕES"
      titulo=""
      descricao=""
      :unidade-id="unidadeId"
      :empresas="empresas"
      mostrar-pessoas
      mostrar-configuracao
      @empresa-selecionada="selecionarEmpresa"
    />
    <b-message v-if="erro" type="is-danger" aria-close-label="Fechar" @close="erro = ''">{{ erro }}</b-message>
    <b-message v-if="empresaCriada" type="is-success" aria-close-label="Fechar" @close="empresaCriada = null"
      >Empresa {{ empresaCriada.nome }} criada com {{ empresaCriada.adminEmail }} como administrador pendente. Abra
      <router-link to="/rh/pessoas">Pessoas</router-link> para enviar o convite de acesso.</b-message
    >
    <b-loading :active="loading" :is-full-page="false"></b-loading>
  
    <b-tabs v-model="abaAtiva" type="is-boxed">
      <b-tab-item value="politica" label="Política">
        <section v-if="unidadeId" class="rh-card">
          <div class="rh-card-head">
            <div>
              <p class="rh-kicker">POR EMPRESA</p>
              <h2>Política de divulgação</h2>
            </div>
            <b-tag :type="politicaConfigurada ? 'is-success' : 'is-warning'">{{
              politicaConfigurada ? 'Configurada' : 'Pendente'
            }}</b-tag>
          </div>
          <p class="rh-muted">
            Resultados só aparecem quando o ciclo alcança o mínimo de respostas. As faixas definem o farol da média
            geral de 1 a 5.
          </p>
          <ValidationObserver v-slot="{ handleSubmit }" slim
            ><form @submit.prevent="handleSubmit(salvarPolitica)">
              <div class="rh-fields">
                <ValidationProvider v-slot="{ errors }" name="Mínimo de respostas" rules="required|integer|min_value:3"
                  ><b-field label="Mínimo de respostas" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                    ><b-input
                      v-model.number="politica.minimoRespostas"
                      type="number"
                      min="3"
                    ></b-input></b-field></ValidationProvider
                ><ValidationProvider v-slot="{ errors }" name="Limite crítico" rules="required"
                  ><b-field label="Crítico abaixo de" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                    ><b-input
                      v-model.number="politica.corteCritico"
                      type="number"
                      min="1"
                      max="5"
                      step="0.01"
                    ></b-input></b-field></ValidationProvider
                ><ValidationProvider v-slot="{ errors }" name="Limite saudável" rules="required"
                  ><b-field label="Saudável a partir de" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                    ><b-input
                      v-model.number="politica.corteSaudavel"
                      type="number"
                      min="1"
                      max="5"
                      step="0.01"
                    ></b-input></b-field
                ></ValidationProvider>
              </div>
              <b-button type="is-primary" native-type="submit" :loading="salvando">Salvar política</b-button>
            </form></ValidationObserver
          >
        </section>
        <div v-else class="rh-card rh-muted">Selecione ou cadastre uma empresa para configurar a política.</div>
      </b-tab-item>
      <b-tab-item v-if="isInRole('rh-diretoria')" value="instrumento" label="Instrumento 9D">
        <section class="rh-card">
          <div class="rh-card-head">
            <div>
              <p class="rh-kicker">MÉTODO GLOBAL</p>
              <h2>Instrumento 9D</h2>
            </div>
            <b-tag :type="instrumentoPronto ? 'is-success' : 'is-warning'">{{
              instrumentoPronto ? '36 afirmações' : 'Pendente'
            }}</b-tag>
          </div>
          <p class="rh-muted">
            Preencha os nomes oficiais das 9 dimensões e 4 afirmações por dimensão. Depois que um ciclo for criado, o
            instrumento fica bloqueado para preservar o histórico.
          </p>
          <div class="rh-progress">
            <span>{{ camposPreenchidos }} de 45 campos preenchidos</span
            ><progress class="progress is-info" :value="camposPreenchidos" max="45">{{ camposPreenchidos }}</progress>
          </div>
          <div v-for="(dimensao, di) in dimensoes" :key="di" class="rh-dimension">
            <div class="rh-dimension-head">
              <span>{{ String(di + 1).padStart(2, '0') }}</span
              ><b-field :label="`Dimensão ${di + 1}`" expanded
                ><b-input
                  v-model.trim="dimensao.nome"
                  maxlength="120"
                  :placeholder="`Nome oficial da dimensão ${di + 1}`"
                ></b-input
              ></b-field>
            </div>
            <div class="rh-questions">
              <b-field v-for="(questao, qi) in dimensao.questoes" :key="qi" :label="`Afirmação ${qi + 1}`"
                ><b-input
                  v-model.trim="dimensao.questoes[qi]"
                  maxlength="1000"
                  type="textarea"
                  rows="2"
                  :placeholder="`Texto oficial da afirmação ${di * 4 + qi + 1}`"
                ></b-input
              ></b-field>
            </div>
          </div>
          <div class="rh-actions">
            <b-button
              type="is-primary"
              :disabled="camposPreenchidos !== 45"
              :loading="salvando"
              @click="confirmarInstrumento"
              >Salvar instrumento</b-button
            >
          </div>
        </section>
      </b-tab-item>
      <b-tab-item v-if="isInRole('rh-diretoria')" value="instrumento-7d" label="Instrumento 7D">
        <section class="rh-card">
          <div class="rh-card-head">
            <div>
              <p class="rh-kicker">MÉTODO GLOBAL</p>
              <h2>Instrumento 7D</h2>
            </div>
            <b-tag :type="instrumento7DPronto ? 'is-success' : 'is-warning'">{{
              instrumento7DPronto ? '28 afirmações' : 'Pendente'
            }}</b-tag>
          </div>
          <p class="rh-muted">Preencha os nomes das 7 dimensões e 4 afirmações por dimensão.</p>
          <div class="rh-progress">
            <span>{{ campos7DPreenchidos }} de 35 campos preenchidos</span
            ><progress class="progress is-info" :value="campos7DPreenchidos" max="35">{{ campos7DPreenchidos }}</progress>
          </div>
          <div v-for="(dimensao, di) in dimensoes7D" :key="di" class="rh-dimension">
            <div class="rh-dimension-head">
              <span>{{ String(di + 1).padStart(2, '0') }}</span
              ><b-field :label="`Dimensão ${di + 1}`" expanded
                ><b-input
                  v-model.trim="dimensao.nome"
                  maxlength="120"
                  :placeholder="`Nome da dimensão ${di + 1}`"
                ></b-input
              ></b-field>
            </div>
            <div class="rh-questions">
              <b-field v-for="(questao, qi) in dimensao.questoes" :key="qi" :label="`Afirmação ${qi + 1}`"
                ><b-input
                  v-model.trim="dimensao.questoes[qi]"
                  maxlength="1000"
                  type="textarea"
                  rows="2"
                  :placeholder="`Texto da afirmação ${di * 4 + qi + 1}`"
                ></b-input
              ></b-field>
            </div>
          </div>
          <div class="rh-actions">
            <b-button
              type="is-primary"
              :disabled="campos7DPreenchidos !== 35"
              :loading="salvando"
              @click="confirmarInstrumento7D"
              >Salvar instrumento 7D</b-button
            >
          </div>
        </section>
      </b-tab-item>
      <b-tab-item value="auditoria" label="Auditoria">
        <section v-if="unidadeId" class="rh-card">
          <div class="rh-card-head">
            <div>
              <p class="rh-kicker">CONTROLE DE ACESSO</p>
              <h2>Auditoria recente</h2>
            </div>
            <b-button size="is-small" type="is-light" icon-left="refresh" @click="carregarAuditoria"
              >Atualizar</b-button
            >
          </div>
          <p class="rh-muted">Últimas 100 ações administrativas registradas nesta empresa.</p>
          <b-table :data="auditoria" paginated :per-page="10" mobile-cards
            ><b-table-column v-slot="p" field="dataHora" label="Data">{{ dataHora(p.row.dataHora) }}</b-table-column
            ><b-table-column v-slot="p" field="usuario" label="Usuário">{{ p.row.usuario }}</b-table-column
            ><b-table-column v-slot="p" field="acao" label="Ação">{{ p.row.acao }}</b-table-column
            ><b-table-column v-slot="p" field="entidade" label="Registro"
              >{{ p.row.entidade }} {{ p.row.registroId || '' }}</b-table-column
            ><template #empty><div class="rh-muted">Ainda não há eventos registrados.</div></template></b-table
          >
        </section>
        <div v-else class="rh-card rh-muted">Selecione ou cadastre uma empresa para consultar a auditoria.</div>
      </b-tab-item>
      <b-tab-item value="empresas" label="Empresas">
        <section class="rh-card">
          <div class="rh-card-head">
            <div>
              <p class="rh-kicker">MULTIEMPRESA</p>
              <h2>Empresas</h2>
            </div>
            <b-button v-if="isInRole('rh-diretoria')" type="is-primary" icon-left="plus" @click="abrirNovaEmpresa">
              Nova empresa
            </b-button>
          </div>
          <p class="rh-muted">Empresas disponíveis para o seu perfil.</p>
          <b-table :data="empresas" :loading="loading" paginated :per-page="10" mobile-cards>
            <b-table-column v-slot="p" field="nome" label="Empresa" sortable>{{ p.row.nome }}</b-table-column>
            <b-table-column v-slot="p" label="Ações" width="100">
              <b-button
                size="is-small"
                type="is-light"
                icon-left="pencil"
                :aria-label="`Editar nome de ${p.row.nome}`"
                @click="abrirEditarEmpresa(p.row)"
              >
                Editar
              </b-button>
            </b-table-column>
            <template #empty><div class="rh-muted">Nenhuma empresa disponível para o seu perfil.</div></template>
          </b-table>
        </section>
      </b-tab-item>
    </b-tabs>
    <b-modal :active.sync="modalEmpresa" has-modal-card trap-focus aria-role="dialog" aria-modal
      ><ValidationObserver v-slot="{ handleSubmit }" slim
        ><form class="modal-card" @submit.prevent="handleSubmit(salvarEmpresa)">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ editandoEmpresa ? 'Editar empresa' : 'Nova empresa' }}</p>
          </header>
          <section class="modal-card-body">
            <ValidationProvider v-slot="{ errors }" name="Nome da empresa" rules="required|min:2|max:30"
              ><b-field label="Nome da empresa" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                ><b-input v-model.trim="empresaForm.nome" maxlength="30"></b-input></b-field></ValidationProvider
            ><template v-if="!editandoEmpresa"
              ><ValidationProvider v-slot="{ errors }" name="Nome do administrador" rules="required|min:2|max:40"
                ><b-field label="Nome do administrador" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                  ><b-input v-model.trim="empresaForm.adminNome" maxlength="40"></b-input></b-field></ValidationProvider
              ><ValidationProvider v-slot="{ errors }" name="E-mail do administrador" rules="required|email"
                ><b-field label="E-mail do administrador" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                  ><b-input v-model.trim="empresaForm.adminEmail" type="email" maxlength="50"></b-input></b-field
              ></ValidationProvider>
              <p class="rh-muted">O administrador será cadastrado e poderá receber um convite de acesso.</p></template
            >
          </section>
          <footer class="modal-card-foot">
            <b-button @click="modalEmpresa = false">Cancelar</b-button
            ><b-button native-type="submit" type="is-primary" :loading="salvando">Salvar</b-button>
          </footer>
        </form></ValidationObserver
      ></b-modal
    >
  </main>
</template>

<script>
import http from '@/http'
import RhCabecalho from '@/components/rh_cabecalho.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'RhConfiguracao',
  components: { RhCabecalho },
  data() {
    return {
      empresas: [],
      unidadeId: null,
      abaAtiva: 'politica',
      politica: { minimoRespostas: null, corteCritico: null, corteSaudavel: null },
      politicaConfigurada: false,
      dimensoes: Array.from({ length: 9 }, () => ({ nome: '', questoes: ['', '', '', ''] })),
      instrumentoPronto: false,
      dimensoes7D: Array.from({ length: 7 }, () => ({ nome: '', questoes: ['', '', '', ''] })),
      instrumento7DPronto: false,
      auditoria: [],
      modalEmpresa: false,
      editandoEmpresa: false,
      empresaEditandoId: null,
      empresaForm: { nome: '', adminNome: '', adminEmail: '' },
      empresaCriada: null,
      loading: false,
      salvando: false,
      erro: '',
    }
  },
  computed: {
    ...mapGetters(['isInRole']),
    camposPreenchidos() {
      return this.dimensoes.reduce((n, d) => n + (d.nome.trim() ? 1 : 0) + d.questoes.filter((q) => q.trim()).length, 0)
    },
    campos7DPreenchidos() {
      return this.dimensoes7D.reduce((n, d) => n + (d.nome.trim() ? 1 : 0) + d.questoes.filter((q) => q.trim()).length, 0)
    },
  },
  created() {
    this.iniciar()
  },
  methods: {
    selecionarEmpresa(id) {
      this.unidadeId = id
      this.carregarPolitica()
    },
    dataHora(v) {
      return v ? new Date(v).toLocaleString('pt-BR') : '—'
    },
    falha(e) {
      this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível concluir a operação. Tente novamente.'
    },
    async iniciar() {
      this.loading = true
      try {
        const [empresas, instrumento] = await Promise.all([
          http.get('/api/rh/estrutura/empresas'),
          http.get('/api/rh/diagnostico/instrumento'),
        ])
        this.empresas = empresas.data || []
        const atual = Number(this.$store.state.unidadeId)
        this.unidadeId = this.empresas.some((x) => x.id === atual)
          ? atual
          : (this.empresas[0] && this.empresas[0].id) || null
        this.instrumentoPronto = !!instrumento.data.pronto
        if (instrumento.data.dimensoes && instrumento.data.dimensoes.length === 9)
          this.dimensoes = instrumento.data.dimensoes.map((d) => ({
            nome: d.nome,
            questoes: d.questoes.map((q) => q.texto),
          }))
        if (this.unidadeId) await this.carregarPolitica()
        if (this.isInRole('rh-diretoria')) await this.carregarInstrumento7D()
      } catch (e) {
        this.falha(e)
      } finally {
        this.loading = false
      }
    },
    async carregarPolitica() {
      this.politicaConfigurada = false
      this.politica = { minimoRespostas: null, corteCritico: null, corteSaudavel: null }
      if (!this.unidadeId) return
      try {
        const p = (await http.get('/api/rh/diagnostico/politica', { params: { unidadeId: this.unidadeId } })).data
        if (p) {
          this.politica = p
          this.politicaConfigurada = true
        }
        await this.carregarAuditoria()
      } catch (e) {
        this.falha(e)
      }
    },
    async carregarAuditoria() {
      try {
        this.auditoria = (await http.get('/api/rh/auditoria', { params: { unidadeId: this.unidadeId } })).data || []
      } catch (e) {
        this.falha(e)
      }
    },
    async carregarInstrumento7D() {
      try {
        const instrumento = (await http.get('/api/rh/diagnostico/instrumento-7d')).data
        this.instrumento7DPronto = !!instrumento.pronto
        if (instrumento.dimensoes && instrumento.dimensoes.length === 7)
          this.dimensoes7D = instrumento.dimensoes.map((d) => ({
            nome: d.nome,
            questoes: d.questoes.map((q) => q.texto),
          }))
      } catch (e) {
        this.falha(e)
      }
    },
    async salvarPolitica() {
      this.salvando = true
      try {
        await http.put('/api/rh/diagnostico/politica', { ...this.politica, unidadeId: this.unidadeId })
        this.politicaConfigurada = true
        this.$buefy.toast.open({ message: 'Política salva.', type: 'is-success' })
      } catch (e) {
        this.falha(e)
      } finally {
        this.salvando = false
      }
    },
    confirmarInstrumento() {
      this.$buefy.dialog.confirm({
        title: 'Salvar instrumento',
        message:
          'O instrumento será usado em todas as empresas e ficará bloqueado após a criação do primeiro ciclo. Confirmar?',
        confirmText: 'Salvar',
        cancelText: 'Cancelar',
        type: 'is-info',
        onConfirm: this.salvarInstrumento,
      })
    },
    async salvarInstrumento() {
      this.salvando = true
      try {
        await http.put('/api/rh/diagnostico/instrumento', this.dimensoes)
        this.instrumentoPronto = true
        this.$buefy.toast.open({ message: 'Instrumento salvo.', type: 'is-success' })
      } catch (e) {
        this.falha(e)
      } finally {
        this.salvando = false
      }
    },
    confirmarInstrumento7D() {
      this.$buefy.dialog.confirm({
        title: 'Salvar instrumento 7D',
        message: 'O cadastro do instrumento 7D será global para todas as empresas. Confirmar?',
        confirmText: 'Salvar',
        cancelText: 'Cancelar',
        type: 'is-info',
        onConfirm: this.salvarInstrumento7D,
      })
    },
    async salvarInstrumento7D() {
      this.salvando = true
      try {
        await http.put('/api/rh/diagnostico/instrumento-7d', this.dimensoes7D)
        this.instrumento7DPronto = true
        this.$buefy.toast.open({ message: 'Instrumento 7D salvo.', type: 'is-success' })
      } catch (e) {
        this.falha(e)
      } finally {
        this.salvando = false
      }
    },
    abrirNovaEmpresa() {
      this.editandoEmpresa = false
      this.empresaEditandoId = null
      this.empresaForm = { nome: '', adminNome: '', adminEmail: '' }
      this.modalEmpresa = true
    },
    abrirEditarEmpresa(empresa) {
      this.editandoEmpresa = true
      this.empresaEditandoId = empresa.id
      this.empresaForm = {
        nome: empresa.nome,
        adminNome: '',
        adminEmail: '',
      }
      this.modalEmpresa = true
    },
    async salvarEmpresa() {
      this.salvando = true
      try {
        if (this.editandoEmpresa) {
          const x = (await http.put(`/api/rh/empresas/${this.empresaEditandoId}`, { nome: this.empresaForm.nome })).data
          this.empresas = this.empresas.map((e) => (e.id === x.id ? x : e))
        } else {
          const x = (await http.post('/api/rh/empresas', this.empresaForm)).data
          this.empresas.push({ id: x.id, nome: x.nome })
          this.unidadeId = x.id
          this.empresaCriada = x
          await this.carregarPolitica()
        }
        this.modalEmpresa = false
        this.$buefy.toast.open({ message: 'Empresa salva.', type: 'is-success' })
      } catch (e) {
        this.falha(e)
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>

<style scoped>
.rh-config {
  --navy: #0b1a3e;
  --blue: #007bff;
  --teal: #0e8fa8;
  background: #f4f3f0;
  min-height: 100vh;
  padding: 0 28px 48px;
  border-radius: 18px;
  color: #1c1d24;
  font-family: Montserrat, Arial, sans-serif;
}
.rh-muted {
  color: #667085;
  font-size: 13px;
}
.rh-kicker {
  letter-spacing: 0.15em;
  font-size: 11px;
  font-weight: 800;
  color: var(--teal);
  margin: 0;
}
.rh-card {
  background: #fff;
  border: 1px solid #e7e9ed;
  border-radius: 17px;
  padding: 26px;
  margin: 16px 0;
  box-shadow: 0 8px 20px rgba(11, 26, 62, 0.04);
}
.rh-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
}
.rh-card h2 {
  font-size: 22px;
  color: var(--navy);
  font-weight: 800;
  margin: 5px 0;
}
.rh-fields {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin: 20px 0;
}
.rh-progress {
  margin: 24px 0;
}
.rh-progress span {
  font-size: 12px;
  color: #667085;
}
.rh-progress progress {
  margin: 8px 0;
}
.rh-dimension {
  border: 1px solid #e5eaf1;
  border-radius: 14px;
  padding: 20px;
  margin: 14px 0;
  background: #fbfcfe;
}
.rh-dimension-head {
  display: flex;
  align-items: center;
  gap: 16px;
}
.rh-dimension-head > span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 11px;
  background: linear-gradient(135deg, var(--blue), #6610f2);
  color: #fff;
  font-weight: 800;
}
.rh-dimension-head .field {
  flex: 1;
}
.rh-questions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  margin-top: 14px;
}
.rh-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
@media (max-width: 800px) {
  .rh-fields,
  .rh-questions {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 560px) {
  .rh-config {
    padding: 0 14px 30px;
  }
  .rh-card {
    padding: 18px;
  }
}
</style>
